import { Component, Input, Output, EventEmitter, computed, signal } from '@angular/core';

import { User } from '@shared/models/user.model';
import { SharedModule } from '@app/shared/shared.module';
import { RecurringHallComponent } from '@app/shared/components/recurring-hall/recurring-hall.component';
import { FriendsComponent } from '@app/home/friends/friends.component';

@Component({
  selector: 'slotcom-profile-tabs',
  templateUrl: './profile-tabs.component.html',
  styleUrls: ['./profile-tabs.component.scss'],
  standalone: true,
  imports: [SharedModule, RecurringHallComponent, FriendsComponent],
})
export class ProfileTabsComponent {
  @Input() user: User;
  @Input() isSelf: boolean;
  @Output() tabChanged = new EventEmitter<number>();

  activeTab = signal(0);
  pendingFriends = signal(0);
  readonly hasPendingFriends = computed(() => this.pendingFriends() !== 0);

  setTab(index: number): void {
    this.activeTab.set(index);
    this.tabChanged.emit(index);
  }

  onPendingFriends(agreed: number): void {
    this.pendingFriends.set(agreed);
  }
}
